<script setup>
// Indicador de teste grátis no rodapé do menu: "Teste grátis · X dias" com
// destaque, linkando pra tela de assinatura. Só aparece durante o teste
// (account.trial.in_trial vindo do DTO da conta).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';

defineProps({
  isCollapsed: {
    type: Boolean,
    default: false,
  },
});

defineOptions({
  // Raiz condicional (RouterLink v-if / else vazio) = fragment; repassamos $attrs.
  inheritAttrs: false,
});

const { t } = useI18n();
const { accountScopedRoute, currentAccount } = useAccount();

const trial = computed(() => currentAccount.value?.trial || null);
const inTrial = computed(() => Boolean(trial.value?.in_trial));
const daysRemaining = computed(() =>
  Math.max(0, Number(trial.value?.days_remaining ?? 0))
);

const label = computed(() =>
  t('SIDEBAR.TRIAL_DAYS_LEFT', daysRemaining.value, {
    count: daysRemaining.value,
  })
);
</script>

<template>
  <RouterLink
    v-if="inTrial"
    v-bind="$attrs"
    :to="accountScopedRoute('billing_settings_index')"
    :title="label"
    class="flex rounded-lg border border-n-amber-6 bg-n-amber-3 hover:bg-n-amber-4 transition-colors"
    :class="
      isCollapsed
        ? 'items-center justify-center size-9'
        : 'flex-col gap-1 px-2 py-2 mx-1'
    "
  >
    <span
      v-if="isCollapsed"
      class="i-lucide-gift size-4 text-n-amber-11 shrink-0"
    />
    <template v-else>
      <div class="flex items-center gap-1.5 text-n-amber-11">
        <span class="i-lucide-gift size-3.5 shrink-0" />
        <span class="text-xs font-medium truncate">{{ label }}</span>
      </div>
      <span class="text-[11px] text-n-amber-11/80 underline underline-offset-2">
        {{ $t('SIDEBAR.TRIAL_SUBSCRIBE') }}
      </span>
    </template>
  </RouterLink>
  <template v-else />
</template>
